<template>
  <v-container fluid>
    <v-card flat class="rounded-lg pa-2" height="100%">
      <div class="rounded-lg pageTitle" style="width: 100%;">
        <v-toolbar-title style="font-weight:bold;">標的物驗收管理</v-toolbar-title>
      </div>
    </v-card>

    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">標的物清單</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportSiteInfoFile" :loading="isExporting">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{overview_total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="siteList"
        :headers="headers"
        hide-default-header
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in headers"
              :key="header.value"
              class="tableTD"
              @click="choseSite(item)"
            >
              <div v-if ="header.value === 'auto_push'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else-if ="header.value === 'ProtectActivated'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
    </v-card>

    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">標的物驗收管理</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportAcceptanceFile" :loading="isExporting">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="acceptancePage"
            :length="acceptancePageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{acceptance_total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="acceptanceRows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="acceptanceList"
        :headers="acceptanceHeaders"
        hide-default-header
        :items-per-page="acceptanceRows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in acceptanceHeaders"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in acceptanceHeaders"
              :key="header.value"
              class="tableTD"
            >
              <div v-if ="header.value === 'FileName'">
                <div>
                  <v-btn depressed  color="success" class="btn_fontSize" @click="downloadAcceptanceFile(item)">下載檔案</v-btn>
                </div>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
    </v-card>

    <!-- 搜尋 sidebar -->
    <v-navigation-drawer
      app
      clipped
      class="rounded-lg mt-3"
      :width="sidebarWidth"
      height="850"
      permanent
    >
      <div class="rowDiv">
        <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
        <v-spacer>
        </v-spacer>
        <v-icon
          size = "30"
          style="cursor: pointer;"
          class="mr-5"
          v-if='sidebarOpen'
          @click="sidebarOpen=!sidebarOpen"
        >
          mdi-arrow-expand-left
        </v-icon>
        <v-icon
          size = "30"
          style="cursor: pointer;"
          class="mr-5 mt-5"
          v-else
          @click="sidebarOpen=!sidebarOpen"
        >
          mdi-tune-variant
        </v-icon>
      </div>
      <v-divider></v-divider>
      <div v-if="sidebarOpen">
        <v-card-title style="height:50px;" class="searchTitle">標的物編號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteId"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">主機編號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteMNO"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">主帳號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-autocomplete
            v-model="searchCustomerId"
            :items="customerList"
            item-text="text"
            item-value="value"
            required
            class="rounded-lg"
            dense
            outlined
            hide-details
            clearable
          >
          </v-autocomplete>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">標的物名稱</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteName"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">合約編號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteContractId"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
      </div>
    </v-navigation-drawer>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Acceptance_form',
  data: () => ({
    isLoading: false,
    isExporting: false,
    headers: [
      { text: '主機編號', value: 'site_mno', sortable: false },
      { text: '所屬管制區', value: 'area_name', sortable: false },
      { text: '標的物名稱', value: 'site_nm', sortable: false },
      { text: '警戒中', value: 'ProtectActivated',  sortable: false },
      { text: '自動推播', value: 'auto_push',  sortable: false },
      { text: '最後設定人員	', value: 'LastProtectedUser',  sortable: false },
      { text: '最後設定時間', value: 'LastProtectedTime',  sortable: false }
    ],
    acceptanceHeaders: [
      { text: '完成時間	', value: 'UploadTime', sortable: false },
      { text: '操作人員', value: 'userName', sortable: false },
      { text: '備註', value: 'Note', sortable: false },
      { text: '檔案名稱', value: 'FileName', sortable: false },
    ],
    rows: 10,
    acceptanceRows: 10,
    sortItem: '',
    sortOrder: true,
    overview_total: 0,
    acceptance_total: 0,
    pageCount: 0,
    acceptancePageCount: 0,
    page: 1,
    acceptancePage: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    siteList: [],
    acceptanceList: [],
    areaList: [],
    allUsersList: [],
    customerList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    searchCustomerId: '',
    searchSiteId: '',
    searchSiteMNO: '',
    searchSiteName: '',
    searchSiteContractId: '',
    searchacceptanceSiteId: ''
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.getDictionary()
  },
  watch: {
    page () {
      this.getPageData()
    },
    acceptancePage () {
      this.getacceptanceDetail()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    searchSiteMNO () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchCustomerId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteName () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteContractId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    acceptanceRows () {
      this.acceptancePage === 1 ? this.getacceptanceDetail() : this.acceptancePage = 1
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    getDictionary () {
      var parm = ['area_info', 'allUsers', 'customer_info']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var areaIndex = response.data.map(function (item) { return item.dicNo }).indexOf('area_info')
            var allUsersIndex = response.data.map(function (item) { return item.dicNo }).indexOf('allUsers')
            var customerIndex = response.data.map(function (item) { return item.dicNo }).indexOf('customer_info')
            var areaList = response.data[areaIndex].data
            var allUsersList = response.data[allUsersIndex].data
            var customerList = response.data[customerIndex].data
            areaList.forEach(element => {
              var area = {
                value: element.key,
                text: element.value
              }
              this.areaList.push(area)
            })
            allUsersList.forEach(element => {
              var users = {
                value: element.key,
                text: element.value
              }
              this.allUsersList.push(users)
            })
            customerList.forEach(element => {
              var customer = {
                value: element.key,
                text: element.key
              }
              this.customerList.push(customer)
            })
            this.getPageData()
          }
        })
    },
    getPageData () {
      this.loading = true
      this.siteList = []
      var searchCustomerId = {
        name: 'customer_id',
        value: this.searchCustomerId,
        displayType: 'like'
      }
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: 'like'
      }
      var searchSiteMNO = {
        name: 'site_mno',
        value: this.searchSiteMNO,
        displayType: 'like'
      }
      var searchSiteName = {
        name: 'site_nm',
        value: this.searchSiteName,
        displayType: 'like'
      }
      var searchSiteContractId = {
        name: 'site_contract_id',
        value: this.searchSiteContractId,
        displayType: 'like'
      }
      var wheres = [searchCustomerId, searchSiteId, searchSiteMNO, searchSiteName, searchSiteContractId]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: 'asc',
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'site_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.overview_total = response.data.total
            this.pageCount = Math.ceil(this.overview_total / this.rows)
            this.siteList = response.data.rows
            this.siteList.forEach(element => {
              var area = this.areaList.find(x => x.value === element.area_id)
              if (area) {
                element.area_name = area.text
              }
              var user = this.allUsersList.find(x => x.value === element.LastProtectedUser)
              if (user) {
                element.LastProtectedUser = user.text
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    choseSite (item) {
      this.searchacceptanceSiteId = item.site_id
      this.getacceptanceDetail()
    },
    getacceptanceDetail () {
      this.acceptanceList = []
      var searchSiteId = {
        name: 'SiteID',
        value: this.searchacceptanceSiteId,
        displayType: '='
      }
      var wheres = [searchSiteId]
      var parm = {
        page: this.acceptancePage,
        rows: this.acceptanceRows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'acceptance_form/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.acceptance_total = response.data.total
            this.acceptancePageCount = Math.ceil(this.acceptance_total / this.acceptanceRows)
            this.acceptanceList = response.data.rows
            this.acceptanceList.forEach(element => {
              var user = this.allUsersList.find(x => x.value === element.UserID)
              if (user) {
                element.userName = user.text
              }
            })
          }
        })
    },
    exportSiteInfoFile () {
      this.isExporting = true
      var searchCustomerId = {
        name: 'customer_id',
        value: this.searchCustomerId,
        displayType: 'like'
      }
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: 'like'
      }
      var searchSiteMNO = {
        name: 'site_mno',
        value: this.searchSiteMNO,
        displayType: 'like'
      }
      var searchSiteName = {
        name: 'site_nm',
        value: this.searchSiteName,
        displayType: 'like'
      }
      var searchSiteContractId = {
        name: 'site_contract_id',
        value: this.searchSiteContractId,
        displayType: 'like'
      }
      var wheres = [searchCustomerId, searchSiteId, searchSiteMNO, searchSiteName, searchSiteContractId]
      var parm = {
        wheres: JSON.stringify(wheres),
        url: 'site_info/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '標的物設備管理.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
        .finally(() => {
          this.isExporting = false
        })
    },
    exportAcceptanceFile () {
      this.isExporting = true
      var searchSiteId = {
        name: 'SiteID',
        value: this.searchacceptanceSiteId,
        displayType: '='
      }
      var wheres = [searchSiteId]
      var parm = {
        wheres: JSON.stringify(wheres),
        url: 'acceptance_form/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '標的物驗收紀錄.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isExporting = false
      })
    },
    downloadAcceptanceFile (item) {
      // console.log(item)
      Service.getBase64File('/acceptance_form/getAcceptanceFile', item.FileSeqno)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            if (response.data.length !== 0) {
              var filename = item.FileName + '.pdf'
              var link = document.createElement('a')
              link.href = 'data:image/png;base64,' + response.data
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()
              link = null
            } else {
              this.showAlert('error', '檔案下載失敗，檔案不存在。')
            }
          }
        })
    },
    BooleanText2YN (value) {
      if(value === null || value === '') {
        return '未設定'
      }
      else if(value.toLowerCase() === 'false') {
        return 'N'
      }
      return 'Y'
    }
  }
}
</script>
